/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { type } from '../../../shared/utility/utilityHelpers';
import { Action } from '@ngrx/store';

export const ActionTypes = {

  GET_LEDGER_LIST_ACTION: type('[Ledgers] Get Ledgers List'),
  GET_LEDGER_LIST_SUCCESS: type('[Ledgers] Get Ledgers List success'),
  GET_LEDGER_LIST_FAIL: type('[Ledgers] Get Ledgers List Fail'),
};

export class GetLedgerListAction implements Action {
  type = ActionTypes.GET_LEDGER_LIST_ACTION;
  constructor(public payload: any) {}
}

export class GetLedgerListSuccessAction implements Action {
  type = ActionTypes.GET_LEDGER_LIST_SUCCESS;
  constructor(public payload: any) {}
}

export class GetLedgerListFailAction implements Action {
  type = ActionTypes.GET_LEDGER_LIST_FAIL;
  constructor(public payload: any = null) {}
}

export type Actions = | GetLedgerListAction | GetLedgerListSuccessAction | GetLedgerListFailAction;